import { render, staticRenderFns } from "./SidebarMenuNextSteps.vue?vue&type=template&id=69f8474a&"
import script from "./SidebarMenuNextSteps.vue?vue&type=script&lang=js&"
export * from "./SidebarMenuNextSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports